import React from 'react';
import { Theme, useMediaQuery } from '@mui/material';
import { Spacer } from '../../../../../components/atoms';
import { Modal } from '../../../../../components/molecules';
import { CenterModalContentStyle, CenterModalStyle } from '../../../../../components/molecules/Modal/style';
import { singleChangeAction } from '../../../../../reducer/helperfunc';
import { DetailsModalCon } from './style';

type BuyNowPayLaterDetailsProp = {
  dispatch: React.Dispatch<Record<string, any>>;
  setIsModalOpen: (number: number) => void;
  nextStep: (number: number) => void;
};

export const BuyNowPayLaterDetails = ({ setIsModalOpen, dispatch }: BuyNowPayLaterDetailsProp) => {
  const sm = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  const setModalClose = () => {
    dispatch(singleChangeAction({ isPaymentModal: false }));
    setIsModalOpen(0);
  };

  return (
    <Modal
      onModalClose={setModalClose}
      maxWidth="500"
      extraModalContentStyle={{ ...CenterModalContentStyle, width: sm ? '550px' : '' }}
      extraModalStyle={CenterModalStyle}>
      <DetailsModalCon>
        <div className="header">
          <h3>We need some of your details</h3>
          <Spacer height="49px" />
          <p>To continue with the BNPL process, we need to verify some of your details</p>
        </div>

        <div>
          {/* <InputCon>
            <span>BVN</span>
            <InputField name="bvn" placeholder="Enter your BVN" />
          </InputCon>
          <Spacer height="17px" /> */}

          {/* <InputCon>
            <span>NIN</span>
            <InputField
              name="nin"
              placeholder="Enter your NIN"
              onChange={handleUpdateFormData}
              value={formData.nin}
              required={true}
              error={formError.nin}
            />
          </InputCon> */}

          <Spacer height="20px" />

          {/* <div className="info">
            <div className="info-card">
              <p>Pay {formatCurrency(1)} to retrieve bank details</p>
            </div>
            <div className="refunds">
              <InfoIcon />
              <p>Payment is refundable but card name should be the same as on bank details </p>
            </div>
          </div>

          <Spacer height="100px" /> */}

          {/* <Button type="submit" isLoading={isLoading} onClick={handleContinue} disabled={isLoading || disabled}>
            Continue
          </Button> */}
          <Spacer height="20px" />
        </div>
      </DetailsModalCon>
    </Modal>
  );
};
